import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { fetchCartSummary } from "../../api/thunks";
import { CartSliceState, CartSummaryOrderType } from "../types";

export const addSummaryExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(fetchCartSummary.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(
    fetchCartSummary.fulfilled,
    (
      state,
      action: PayloadAction<{
        totalQuantity: number;
        orderType?: CartSummaryOrderType;
      }>,
    ) => {
      const { totalQuantity, orderType } = action.payload;

      if (orderType === 1) {
        state.totalProdCount = totalQuantity;
      } else if (orderType === 2) {
        state.totalRemainsCount = totalQuantity;
      } else if (orderType === 3) {
        state.totalDealerRemainsCount = totalQuantity;
      } else {
        state.totalCount = totalQuantity;
      }
      state.totalCartCount = totalQuantity;
      state.error = null;
      state.isLoading = false;
    },
  );
  builder.addCase(fetchCartSummary.rejected, (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  });
};
